import { connect } from 'react-redux'
import editableSelector from './editableSelector'
import {
  add as addUnsavedChange,
  remove as removeUnsavedChange
} from 'store/redux/unsavedChanges'
import Editable from './Editable'

export default connect(
  editableSelector,
  {
    addUnsavedChange,
    removeUnsavedChange
  },
  null,
  {
    forwardRef: true
  }
)(Editable)

